// Common Zod schemas used across the contract.
import { z } from 'zod';

/**
 * Generic row schema for tables whose payload is a JSON blob in SQLite.
 * Every row has a stable string `id`; everything else is passed through.
 *
 * We use `.passthrough()` so the typed contract stays stable as TS types in
 * the seed evolve. The strongly-typed `clientRowSchema` (see clients.ts) is
 * the tracer that proves we *can* tighten any specific table when wanted.
 */
export const rowBaseSchema = z
    .object({
        id: z.string().min(1),
    })
    .passthrough();

export type RowBase = z.infer<typeof rowBaseSchema>;

/** Where-clause for list queries (`?status=Open&client_id=cl-1`). */
export const listFilterSchema = z.record(z.string(), z.string()).optional();

/** Generic success envelope returned by named actions. */
export const actionResultSchema = z.object({
    ok: z.boolean(),
    data: z.unknown().optional(),
    error: z.string().optional(),
    invalidate: z.array(z.string()).optional(),
});

export type ActionResult = z.infer<typeof actionResultSchema>;
